export default class Compare {
    static initial() {
        this.heightTable();
        this.hideShowOptions();
        this.changeCategory();

        let self = this;
        $(document).bind('refresh.compare.page', function () {
            self.heightTable();
            self.hideShowOptions();
            self.changeCategory();
            if($(window).width() >= 1200) {
                $('.scrollbar-inner').scrollbar();
            }
        })
    }

    /**
     * Set height for each tr on fixed menu
     * >= 768px
     */
    static heightTable() {
        //Cut title before height calculation

        $(".compare_items_wrap .item_product_first .title").dotdotdot({
            height: 60,
            watch: 'window'
        });

        $(window).on("orientationchange",function(){
            setTimeout(function () {
                initBigHVersion();
            }, 500);
        });

        function initBigHVersion() {
            $('.compare_items_wrap').each(function () {
                let $thisWrap = $(this);
                $thisWrap.find('.compare_scroll table tr').each(function (index) {
                    let indexN = index + 1;

                    //Check who the biggest
                    let tScrollH = $(this).height(),
                        tStaticH = $thisWrap.find('.compare_static tr:nth-child('+ indexN +')').height();
                    if(tScrollH >= tStaticH) {
                        $thisWrap.find('.compare_static tr:nth-child('+ indexN +')').css('height', tScrollH);
                    } else {
                        $thisWrap.find('.compare_scroll table tr:nth-child('+ indexN +')').css('height', tStaticH);
                    }
                });
                $thisWrap.css('opacity', 1);
            });

            $('.compare_cat_wrap.hide_after_init').hide();
        }
        //TODO
        setTimeout(function () {
            initBigHVersion();
        }, 500)
    }

    /**
     * Show all or only same options
     */
    static hideShowOptions() {

        //>= 768
        if($(window).width() >= 768) {
            $('.compare_static .form_style input[type="radio"]').on('change', function () {
                actions($(this).val(), $(this).closest('.compare_cat_wrap').find('table'));
            });
        }
        if($(window).width() <= 767) {
            $('.compare_control_mob ul').on('click', 'a:not(.active)', function (e) {
                e.preventDefault();
                $(this).closest('ul').find('.active').removeClass('active');
                $(this).addClass('active');
                actions($(this).attr('data-type'), $(this).closest('.compare_cat_wrap').find('table'));
            });
        }

        function actions(status, $tables) {
            let $compareTables = $tables;
            if(status === '1') {
                $compareTables.find('tr').show();
            } else {
                $compareTables.find('tr[data-same="true"]').hide();
                $compareTables.find('tr[data-same="false"]').show();
            }
        }

    }

    /**
     * Change category
     */
    static changeCategory() {
        let $catControl = $('.compare_wrap .compare_categories'),
            $contentCategory = $('.compare_wrap .content');

        $catControl.on('click', 'li a', function (e) {
            e.preventDefault();
            if($(this).hasClass('active')) return true;

            $(this).closest('ul').find('a.active').removeClass('active');
            $(this).addClass('active');

            let $findShow = $('.compare_cat_' + $(this).attr('data-id'));
            $contentCategory.find('> div').not($findShow).animate({opacity: 0}, 200, function() {
                $contentCategory.find('> div').not($findShow).hide();

                $findShow.show();
                $findShow.animate({opacity: 1}, 200);
            });
        });
    }

}
